import axios from 'axios';
import config from '../common/config';

export default {
  getAssignedRideKeyInformation( rideAssignedKey )
  {
    const formData = new FormData()
    formData.append('rideAssignedKey', rideAssignedKey);
    return axios.post(`${config.config.ROOT_URL}/get_assigned_ride_key_information`,formData, {
      headers: {
        'content-type': 'multipart/form-data'        }
    });
  },

  getRedirectLinkFromRideId( rideId )
  {
    const formData = new FormData()
    formData.append('rideId', rideId);
    return axios.post(`${config.config.ROOT_URL}/get_redirect_page_from_ride_id`,formData, {
      headers: {
        'content-type': 'multipart/form-data'        }
    });
  },

  assignUserToLockedRide( token, rideKeyValue, subdomain )
    {
      
      const formData = new FormData()
      formData.append('rideKeyValue', rideKeyValue);
      formData.append('subdomain', subdomain);
      return axios.post(`${config.config.ROOT_URL}/add_user_to_ride_privacy_api`,formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'content-type': 'multipart/form-data'        }
      });
    },

    getOrCreateFullRideAccesskeyInformation( token, rideId )
    {
      const formData = new FormData()
      formData.append('rideId', rideId);
      return axios.post(`${config.config.ROOT_URL}/get_assigned_ride_key_full_information`,formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'content-type': 'multipart/form-data'        }
      });
    },

    updateRideAccessKeyInformation( token, rideAccessKeyInformation)
    {
      const formData = new FormData()
      formData.append('rideAccessKeyInformation', JSON.stringify(rideAccessKeyInformation));
      return axios.post(`${config.config.ROOT_URL}/update_assigned_ride_key_full_information`,formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'content-type': 'multipart/form-data'        }
      });
    },
    getOneUserAccessKey( token, rideOneTimeAccessKeyInformation)
    {
      const formData = new FormData()
      formData.append('rideOneTimeAccessKeyInformation', JSON.stringify(rideOneTimeAccessKeyInformation));
      return axios.post(`${config.config.ROOT_URL}/get_one_user_access_key`,formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'content-type': 'multipart/form-data'        }
      });
    },

    getRideConnectedUsers(token, rideId) {
      return axios.get(`${config.config.ROOT_URL}/get_ride_connected_users/${rideId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
    },

    revokeUserRideAccess(token, rideId, email, blockLink = false) {
      return axios.post(
        `${config.config.ROOT_URL}/revoke_user_ride_access`,
        { ride_id: rideId, email, block_link: blockLink },
        { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
      );
    },

    restoreUserRideAccess(token, rideId, email) {
      return axios.post(
        `${config.config.ROOT_URL}/restore_user_ride_access`,
        { ride_id: rideId, email },
        { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
      );
    },

    getRideCopiedUsers(token, rideId) {
      return axios.get(`${config.config.ROOT_URL}/get_ride_copied_users/${rideId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
    },

    getUserBlockStatus(token, email) {
      return axios.post(
        `${config.config.ROOT_URL}/admin/user_block_status`,
        { email },
        { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
      );
    },

    setUserBlocked(token, email, block) {
      return axios.post(
        `${config.config.ROOT_URL}/admin/block_user`,
        { email, block },
        { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
      );
    },

    restoreRideAccessLink(token, rideId) {
      return axios.post(
        `${config.config.ROOT_URL}/restore_ride_access_link`,
        { ride_id: rideId },
        { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
      );
    },
};
